import React from "react";

import { useField } from "formik";

import { Input } from "components/Form/FormikControls";

import { getGSTStatusText } from "lib/businesses";

export function GSTField(props) {
  const { name, abrLastChecked, isABNActive } = props;

  const [{ value: isGstRegistered }] = useField(name);

  return (
    <Input
      disabled
      label="GST Status"
      name={name}
      overrideValue={getGSTStatusText(
        isABNActive,
        isGstRegistered,
        abrLastChecked,
      )}
      tooltip="Populated after adding an ABN and querying the ABR."
    />
  );
}
